import styled from 'styled-components'
import CertifiedPurchaseTagTestABCard from '../CertifiedPurchase/TagTestABCard'

export const Link = styled.a`
  text-decoration: none;
  margin-top: auto;
`

export const LinkWithGrow = styled(Link)`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
`

export const AlignHorizontalInfoAreaStamp = styled.div`
  position: absolute;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;

  div {
    margin-right: 5px;
    margin-bottom: 5px;
  }
`

export const AlignHeaderStamp = styled.div`
  display: flex;
  margin: 6px 0px 0 12px;
`

export const AlignSuperPrecoStamp = styled.div`
  position: absolute;
  top: 0;
  right: 12px;
`

export const AlignFlagsStamp = styled.div`
  position: absolute;
  top: 0;
  right: 6px;
  display: flex;
  flex-direction: row-reverse;
  & > div {
    margin: 0 2px;
  }
`
export const PictureWrapper = styled.div`
  position: relative;
`

export const CertifiedPurchaseTestAB = styled(CertifiedPurchaseTagTestABCard)`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
`

export const LineContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 40px;
`

export const StampsContainer = styled.div`
  margin-top: 2px;
`

export const FavoriteContainer = styled.div`
  position: absolute;
  right: 0;
  top: 2px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  margin-right: 12px;

  & > div {
    padding-top: 4px;
    width: 24px;
    height: 24px;
  }

  svg {
    width: 24px;
    height: 24px;
  }
`

export const DetailContainer = styled.div`
  margin-left: -4px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #696977;
`

export const InfoContainer = styled.div`
  flex-grow: 1;

  & > div:first-child {
    padding: 7px 12px 8px;

    h2,
    h3 {
      width: 220px;
    }

    h3 {
      color: #696977;
    }

    h2 {
      font-size: 16px;
      font-weight: 600;
      line-height: 150%;
      width: 98%
    }
  }
`

export const PriceContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 16px;
  margin-bottom: 8px;
  margin-top: 16px;

  strong {
    margin-bottom: 0;
    font-size: 20px;
    font-weight: 600;
    padding-right: 0;
  }
`

export const Division = styled.hr`
    background-color: #ECEDF2;
    height: 1px;
    border: 0;
    margin-top: 15px;
`
